require('./payrollLoanRequestStepTwo.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLink } = require('commonsComponents/OKLink');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @components
const PayrollLoanPaginator = require('../../../contractPayrollLoan/payrollLoanPaginator/payrollLoanPaginator');
const PayrollLoanDocumentActions = require('../../../contractPayrollLoan/payrollLoanDocumentActions/payrollLoanDocumentActions');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

//@utilities
const { decimalsLength, getFormattedString } = require('utilities/currencyHelper');
const { NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES } = require("constants/flagBasedFeatures");
//@constants
const { findPurposeById } = require('../../../contractPayrollLoan/payrollLoanPurposes');

// @Contact Center
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');

class PayrollLoanRequestStepTwo extends React.Component {
    constructor(props) {
        super(props);

        this.state = { currentPage: 0 };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePrint = this.handlePrint.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
    }

    buildActions() {
        const handlers = {
            handlePrint: this.handlePrint,
            handleDownload: this.handleDownload
        }

        return (
            <PayrollLoanDocumentActions
                download
                print
                handlers={handlers}
            />
        );
    }

    buildCongratz() {
        const { immPayrollLoanRequest, isDragoFeature } = this.props;

        const rawSelectedAmount = immPayrollLoanRequest.get('selectedAmount');
        let selectedPurposeText;
        if (isDragoFeature) {
            const purposeElement = immPayrollLoanRequest.get('newPurposesList').find(purposeElement => purposeElement.get('id') === immPayrollLoanRequest.get('selectedPurposeDrago'));
            selectedPurposeText = !!purposeElement ? purposeElement.get('text') : '';
        } else {
            const selectedPurpose = immPayrollLoanRequest.get('selectedPurpose');
            const purposeObject = findPurposeById(selectedPurpose);
            const selectedPurposeTransKey = purposeObject ? purposeObject.stepTwoTransKey : null;
            selectedPurposeText = selectedPurposeTransKey ? formatText(selectedPurposeTransKey) : '';
        }

        const decimalsLengthLoanImport = decimalsLength(rawSelectedAmount);
        const selectedAmount = getFormattedString({
            amount: rawSelectedAmount,
            currency: immPayrollLoanRequest.get('currency'),
            decimalsLength: decimalsLengthLoanImport
        });

        const congratzValues = [
            selectedAmount,
            immPayrollLoanRequest.get('selectedTerm'),
            selectedPurposeText
        ];

        return (
            <FormattedText
                value="payrollLoanRequest-stepTwoCongratz"
                injectedStrings={congratzValues}
                className="payroll-loan-request-step-two__congratz"
            />
        );
    }

    buildContent() {
        const { immPayrollLoanRequest, immFlagBasedFeatures } = this.props;
        const pages = immPayrollLoanRequest.get('pages');
        const personalLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES);
        const congratz = this.buildCongratz();
        const paginator = this.buildPaginator(pages);
        const viewer = this.buildViewer(pages);
        const documentActions = this.buildActions();
        const validDateMessage = this.buildValidDateMessage();
        const ine = this.buildIne();
        const emailSentBlockInfo = (
            <ContactCenterRender>
                <BlockInfo>
                    <FormattedText value="payrollLoanRequestStepTwo-emailSentBlockInfo" />
                </BlockInfo>
            </ContactCenterRender>
        );
        return (
            <div className="payroll-loan-request-step-two">
                <div>
                    {congratz}
                </div>
                <div className="payroll-loan-request-step-two__remember">
                    {validDateMessage}
                </div>
                {paginator}
                {viewer}
                {documentActions}
                 {!personalLoanFF &&
                    emailSentBlockInfo
                }
                {ine}
            </div>
        );
    }

    buildIne() {
        const { immPayrollLoanRequest, onDownloadINE, immFlagBasedFeatures } = this.props;
        const proposition = immPayrollLoanRequest.get('proposition');
        const isFetchingPrintDocuments = immPayrollLoanRequest.get('isFetchingPrintDocuments');
        const personalLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES);
        return proposition.get('success') && !isFetchingPrintDocuments ? (
            <>
                {personalLoanFF ?
                    <div className="payroll-loan-request-step-two__ine">
                        <FormattedText value="payrollLoanRequest-personalLoanRequestStepTwoFooter" />

                    </div>
                    :
                    <div className="payroll-loan-request-step-two__ine">
                        <FormattedText value="payrollLoanRequest-ineText1" />
                        <OKLink
                            modifier="emphasize"
                            onClick={onDownloadINE}
                        >
                            <FormattedText value="payrollLoanRequest-ineText2" />
                        </OKLink>
                        <FormattedText value="payrollLoanRequest-ineText3" />
                    </div>

                }
            </>
        ) : <LoadingSection />;
    }

    buildPaginator(pages) {
        const { currentPage } = this.state;

        return pages ? (
            <PayrollLoanPaginator
                pages={pages.size}
                current={currentPage}
                onPageChange={this.handlePageChange}
            />
        ) : null;
    }

    buildValidDateMessage() {
        const { immPayrollLoanRequest } = this.props;
        const expirationDate = immPayrollLoanRequest.get('expirationDate');

        return (
            <FormattedText
                value="payrollLoanRequest-stepTwoRemember"
                injectedStrings={[expirationDate]}
            />
        );
    }

    buildViewer(pages) {
        const { currentPage } = this.state;
        const { immPayrollLoanRequest } = this.props;
        const isFetching = immPayrollLoanRequest.get('isFetching');
        const page = pages.get(currentPage);

        const content = page ? (
            <div className="payroll-loan-request-step-two__document-viewer">
                <img
                    title={page.get('filename')}
                    src={page.get('base64')}
                    className="payroll-loan-request-step-two__document-viewer-image"
                />
            </div>
        ) : null;

        return isFetching ? (
            <LoadingSection />
        ) : content;
    }

    handleDownload() {
        const { onActionApprovalLetter } = this.props;

        onActionApprovalLetter('download');
    }

    handlePageChange(currentPage) {
        this.setState({ currentPage });
    }

    handlePrint() {
        const { onActionApprovalLetter } = this.props;

        onActionApprovalLetter('print');
    }

    render() {
        const { immPayrollLoanRequest } = this.props;
        const isFetching = immPayrollLoanRequest.get('isFetching');

        return isFetching ? (
            <LoadingSection />
        ) : this.buildContent();
    }
}

PayrollLoanRequestStepTwo.propTypes = {
    immPayrollLoanRequest: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    isDragoFeature: PropTypes.bool.isRequired,
    onActionApprovalLetter: PropTypes.func.isRequired,
    onDownloadINE: PropTypes.func.isRequired,
    getAsnefValidation: PropTypes.func.isRequired,
};

module.exports = PayrollLoanRequestStepTwo;
